import { render } from "./inventory.vue?vue&type=template&id=40eea963&ts=true"
import script from "./inventory.vue?vue&type=script&lang=ts"
export * from "./inventory.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__